import React from 'react'
import PropTypes from 'prop-types'
import StickyHeader from 'components/StickyHeader'
import StickyHeaderWrapper from 'components/common/StickyHeaderWrapper'
import { MAIN_CONTENT, FOOTER } from 'constant'
import { injectProps } from 'helpers/utils'
import MyGaragePage from '../MyGarage2.0'
import { NEXT_APPOINTMENT_MY_GARAGE_CLASS } from 'components/MyGarage2.0/constants'

const OneColumnGaragePage = ({ placeholders: { footer = [], header = []} = {}, cartridgesMap, ...props }) =>
  <React.Fragment>
    <StickyHeaderWrapper>
      { header }
      <StickyHeader />
    </StickyHeaderWrapper>

    <main id={ MAIN_CONTENT } tabIndex="-1" data-max-width data-max-width-padding>
      {cartridgesMap.GarageContentSlotMain}

      <MyGaragePage>
        {cartridgesMap.BOTGarageVehicles}
        {cartridgesMap.MyGarageEducationContentDetails}
        {injectProps(cartridgesMap.BOTMyAppointmentsDetailsMyGarage, { className: NEXT_APPOINTMENT_MY_GARAGE_CLASS })}
      </MyGaragePage>

      {cartridgesMap.PromotionResultListMyGarage}
    </main>

    <div id={ FOOTER }>
      { footer }
    </div>
  </React.Fragment>

OneColumnGaragePage.propTypes = {
  '@type': PropTypes.string,
  cartridgesMap: PropTypes.shape(),
  metaDescription: PropTypes.string,
  metaKeywords: PropTypes.string,
  name: PropTypes.string,
  placeholders: PropTypes.shape({
    footer: PropTypes.arrayOf(),
    header: PropTypes.arrayOf()
  }),
  title: PropTypes.string
}

export default OneColumnGaragePage
